
import { defineComponent, ref, onUpdated } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Form',
    },
    data: {
      type: Object,
    },
  },
  setup (props) {
    const formRef = ref()
    const form = ref(props.data) as any
    const name = ref('Check Status')
    const store = useStore()

    const comments = ref([])



    onUpdated(() => {
        store.dispatch('ApTcommentHistory/show',form.value.transaction_id).then((res) => {
          console.log(res)
            comments.value = res.data
        })
    })

    return {
        form,
        formRef,
        name,
        comments,
    }
  },
})
